import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Document',
  moduleId: MODULE_ID, //used as vuex store module id
  api: 'documents',

  routeHandler,
};

export default module;
